<script setup>
const props = defineProps({
  data: Object
})
const { getCarouselContent } = useCarouselContentData();
const { data: carouselContent } = await getCarouselContent();

let carouselData = null;
if (props.data.override) {
    carouselData = carouselContent.value.carouselContent  
} else {
    carouselData = props.data.carouselContent
}
const carouselSliderId = 'carousel-content-' + props.data.id;
onMounted(() => {
  const indicators = document.querySelectorAll(`#${carouselSliderId} .carousel-indicators .rounded-circle`);
  if (indicators.length > 1) {
    // Trigger a click event on the second element (index 1)    
    indicators[0].click();
  }
});
</script>

<template>
  <div class="block carousel-content">
    <template v-if="carouselData.length">
      <div class="container">
        <div class="row">
          <div class="col">
        <div :id="carouselSliderId" class="carousel slide" data-bs-interval="false">
          <ol class="carousel-indicators">
            <template v-if="carouselData.length > 1">
              <li v-for="(data, index) in carouselData" 
                :key="index" 
                :data-bs-target="'#' + carouselSliderId" 
                :data-bs-slide-to="index" 
                :class="['rounded-circle', 'my-0', 'mx-2', index === 0 ? 'active' : '']">
              </li>
            </template>
          </ol>
          <div class="carousel-inner">
            <div v-for="(data, index) in carouselData" :key="`item-${data.id}-${index}`" class="carousel-item" :class="index === 0 ? 'active' : ''" >
              <div class="carousel-wrapper pb-2 pb-lg-0">
                <div class="carousel-item-image col-4 px-0">
                  <!-- Mobile Image -->
                  <NuxtImg v-if="data.mobileImage"
                    :src="data.mobileImage.url" 
                    :alt="data.mobileImage.alternativeText" 
                    :title="data.mobileImage.caption" 
                    :class="data.mobileImage ? 'd-lg-none' : ''"
                    aria-hidden=”true”
                  />
                    <!-- Desktop image -->
                  <NuxtImg 
                    :src="data.image.url" 
                    :alt="data.image.alternativeText" 
                    :title="data.image.caption" 
                    :class="data.mobileImage ? 'd-none d-lg-block' : ''"  
                    aria-hidden=”true”
                  />
                </div>
                <div class="carousel-item-content col-8 d-none d-lg-block">
                  <UIHeading 
                    :titleComponent="data.highlightText" 
                    :titleClass="'title '" />
                  <article v-html="data.personalInfo"></article>
                  <article v-html="data.content"></article>
                  <div class="py-4">
                    <NuxtImg v-if="data.brandImage"
                      :src="data.brandImage.url"
                      :alt="data.brandImage.alternativeText"
                      :title="data.brandImage.caption"  
                      aria-hidden=”true”
                    />
                  </div>
                </div>
                <div class="carousel-item-content d-lg-none">
                  <UIHeading 
                    :titleComponent="data.highlightText" 
                    :titleClass="'title '" />
                  <article v-html="data.personalInfo"></article>
                </div>
              </div>
              <div class="d-lg-none">
                <article v-html="data.content"></article>
                <div class="py-2">
                  <NuxtImg v-if="data.brandImage"
                    :src="data.brandImage.url"
                    :alt="data.brandImage.alternativeText"
                    :title="data.brandImage.caption" 
                    aria-hidden=”true”
                  />
                </div>
              </div>
            </div>
          </div>
         
          <a v-if="carouselData.length > 1" class="carousel-control-next d-none d-md-flex" href="#" role="button" data-bs-slide="next" :data-bs-target="'#' + carouselSliderId">
            <span class="circle"><i class="icon-chevron-right"></i></span>
          </a>
          <a v-if="carouselData.length > 1" class="carousel-control-prev d-none d-md-flex" href="#" role="button" data-bs-slide="prev" :data-bs-target="'#' + carouselSliderId">
            <span class="circle"><i class="icon-chevron-left"></i></span>
          </a>
        </div>
      </div></div>
        </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.carousel-content {
  .carousel {
    cursor: default;
  }

  .carousel-inner {
    border-radius: 24px;
    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.08);
    background-color: #fff;

    .carousel {
      display: flex;
    }

    .carousel-wrapper {
      display: flex;
      align-items: stretch; /* Make all items the same height */
    }

    .carousel-item-image img {
      width: 100%;
      height: 100%; /* Fill the height of its parent container */
      object-fit: cover; /* Maintain aspect ratio and crop if necessary */
      border-radius: 24px;
    }

    .carousel-item-content {
      padding-left: 1rem;
      display: flex;
      flex-direction: column;
    }

    .carousel-item-content h2,
    .carousel-item-content p {
      margin: 0;
    }
  }

  .carousel-control-next{
    text-decoration: none;
  }
  .carousel-control-prev{
    text-decoration: none;
  }

  .icon-chevron-right, .icon-chevron-left {
      font-size: 1.75rem;
      line-height: inherit;
  }

  .circle {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    line-height: 42px;
    background-color: black;
    opacity: 0.4;

    @include media-breakpoint-up(lg) {
      width: 52px;
      height: 52px;
      line-height: 52px;
    }

    &:hover{
      opacity: 0.6;
    }
  }
  .carousel-indicators {
    left: auto;
    bottom: -10px;

    @include media-breakpoint-up(lg) {
      bottom: 10px;
    }

    li {
      cursor: pointer;
      opacity: 0.4;
      overflow: hidden;
      transition: all $animation-duration-default ;
      width: 12px;
      height: 12px;
      background-color: #dedede;
    }

    .active {
      opacity: 1;
      background-color: $color-id-green;
    }
  }
}
</style>